// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, "._3fgTAAt5x{padding:16px 20px}@media (max-width: 767px){html[data-supports-mobile=true] ._3fgTAAt5x{padding:12px 16px}html[data-supports-mobile=true] ._3fgTAAt5x._7uOWYP95x ._5d5rZR4Px{padding:8px 0;margin:-8px 0}}._1WQ4VQTux{display:flex;align-items:flex-start;flex-shrink:0;max-width:100%}._6LNLD0LTx{margin-bottom:-4px;display:none;position:relative}@media (max-width: 767px){html[data-supports-mobile=true] ._6LNLD0LTx{display:inline-flex}}._4Gz5Hbeix{}._1wzp1hZ3x{padding:24px 32px}@media (min-width: 1300px){._1wzp1hZ3x{padding:24px 32px}}@media (min-width: 1500px){._1wzp1hZ3x{padding:24px 32px}}._1wzp1hZ3x._6QNcapmwx{padding-left:12px;padding-right:12px;display:flex;align-items:center;padding-top:0;padding-bottom:0;height:48px}@media (max-width: 767px){html[data-supports-mobile=true] ._1wzp1hZ3x{padding:16px}}._3NR6MAyNx{padding:24px 20px}@media (min-width: 1300px){._3NR6MAyNx{padding:24px 32px}}@media (min-width: 1500px){._3NR6MAyNx{padding:24px 32px}}@media (max-width: 767px){html[data-supports-mobile=true] ._3NR6MAyNx{padding:16px}}._6CLDSR2nx{padding-bottom:0}._6CLDSR2nx .PYk6L9jix{flex-direction:column}._5d5rZR4Px{flex:1 1 auto;max-width:100%;overflow:hidden;padding:4px;margin:-4px}._5CgrvSxSx>._1WQ4VQTux>._5d5rZR4Px{display:flex;align-items:baseline}._5CgrvSxSx>._1WQ4VQTux>._5d5rZR4Px>.PYk6L9jix{margin-right:8px}.PYk6L9jix{display:flex;box-sizing:border-box}.PYk6L9jix>*{max-width:100%}.PYk6L9jix>h2{margin:0}[data-panel-position=secondary] .PYk6L9jix{height:48px;max-height:none}[data-panel-position=secondary] ._5d5rZR4Px{overflow:visible}._23aqTwJDx{display:flex;margin-right:8px;align-self:center}._3EqaHtpzx>._1WQ4VQTux>._5d5rZR4Px>.PYk6L9jix{padding-top:4px;padding-bottom:4px}._13rV2yOxx>._1WQ4VQTux>._5d5rZR4Px>.PYk6L9jix{padding-top:4px;padding-bottom:4px}._14B1tQiHx{height:32px;flex:0 0 auto;margin-left:8px}._14B1tQiHx>._4VSwqu1Rx:last-child{margin-right:-4px}[data-panel-position=secondary] ._14B1tQiHx{display:none}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"header-area": "_3fgTAAt5x",
	"headerArea": "_3fgTAAt5x",
	"has-back-button": "_7uOWYP95x",
	"hasBackButton": "_7uOWYP95x",
	"text-area": "_5d5rZR4Px",
	"textArea": "_5d5rZR4Px",
	"bar": "_1WQ4VQTux",
	"back": "_6LNLD0LTx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["unanchor"] + "",
	"divided-header": "_4Gz5Hbeix " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["bottom-divider-inset"] + "",
	"dividedHeader": "_4Gz5Hbeix " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["bottom-divider-inset"] + "",
	"padding-panel": "_1wzp1hZ3x",
	"paddingPanel": "_1wzp1hZ3x",
	"in-secondary": "_6QNcapmwx",
	"inSecondary": "_6QNcapmwx",
	"padding-modal": "_3NR6MAyNx",
	"paddingModal": "_3NR6MAyNx",
	"stick-wizard-menu": "_6CLDSR2nx",
	"stickWizardMenu": "_6CLDSR2nx",
	"title-area": "PYk6L9jix",
	"titleArea": "PYk6L9jix",
	"inline": "_5CgrvSxSx",
	"icon": "_23aqTwJDx",
	"small": "_3EqaHtpzx",
	"medium": "_13rV2yOxx",
	"toolbar": "_14B1tQiHx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["vertically-center"] + "",
	"shift-right": "_4VSwqu1Rx",
	"shiftRight": "_4VSwqu1Rx"
};
module.exports = exports;
